'use client';

import { getCoreRowModel, useReactTable } from '@tanstack/react-table';

import { SKILL_COLUMNS } from '@/app/(app)/settings/skills/table/columns';
import { DataTable } from '@/components/data-table';
import { useApiV1Ctx } from '@/components/providers/v1-api';

export function SkillsTable() {
  const { api } = useApiV1Ctx();
  const { data } = api.skills.getAllSkillsGet.useQuery();

  const table = useReactTable({
    data: data ?? [],
    columns: SKILL_COLUMNS,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className='overflow-hidden rounded-md border'>
      <DataTable table={table} columns={SKILL_COLUMNS} className='overflow-hidden' />
    </div>
  );
}
